import { CLEAR_VISORIAS_STATE, SET_ALL_VISORIAS_POST, SET_HIDE_MODAL_POST, SET_NEW_VISORIA_POST, SET_SHOW_MODAL_POST } from "../constans"

export const setShowModalPost = ()=> dispatch =>{
    dispatch({type: SET_SHOW_MODAL_POST})

}

export const setHideModalPost = ()=> dispatch =>{
    dispatch({type: SET_HIDE_MODAL_POST})
}

export const clearVisoriasState = ()=> dispatch =>{
    dispatch({type: CLEAR_VISORIAS_STATE})
}

export const setNewVisoriaPost = newPost => dispatch  =>{
    dispatch({
        type: SET_NEW_VISORIA_POST,
        payload: newPost,
    })
}

export const setAllVisoriasPost = allPost => dispatch =>{
    dispatch({
        type: SET_ALL_VISORIAS_POST,
        payload: allPost
    })
}